module.exports = __webpack_public_path__ + "static/media/um.33748b82.svg";